import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const CertificateofInsuranceList = Loadable(
  lazy(() =>
    import("./CertificateofInsuranceList").then(
      ({ CertificateofInsuranceList }) => ({ default: CertificateofInsuranceList })
    )
  )
);

const CSIOCertificatePage = Loadable(
  lazy(() =>
    import("../CSIOCertificate/CSIOCertificatePage").then(
      ({ CSIOCertificatePage }) => ({ default: CSIOCertificatePage })
    )
  )
);
const CertificatePropertyInsurance = Loadable(
  lazy(() =>
    import("../PropertyInsuranceCertificate/PropertyInsuranceCertificate").then(
      ({ PropertyInsuranceCertificate }) => ({
        default: PropertyInsuranceCertificate,
      })
    )
  )
);
const CertificateGarageInsuranceInsurance = Loadable(
  lazy(() =>
    import("../GarageCertificate/GarageCertificate").then(
      ({ GarageCertificate }) => ({ default: GarageCertificate })
    )
  )
);

export const businessCertificateOfInsuranceRouter = [
    {
       path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId`,
       exact: true,
       element: (
         <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
           <CertificateofInsuranceList />
         </AuthorizedRoute>
       ),
     },
       {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CSIOCertificatePage />
          </AuthorizedRoute>
        ),
      },
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability/:liabilityNumber`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CSIOCertificatePage />
          </AuthorizedRoute>
        ),
      },
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/liability/duplicate/:liabilityNumber`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CSIOCertificatePage isDuplicate />
          </AuthorizedRoute>
        ),
      },
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/property-insurance`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CertificatePropertyInsurance />
          </AuthorizedRoute>
        ),
      },
    
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/property-insurance/:liabilityNumber`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CertificatePropertyInsurance />
          </AuthorizedRoute>
        ),
      },
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/property-insurance/duplicate/:liabilityNumber`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CertificatePropertyInsurance isDuplicate />
          </AuthorizedRoute>
        ),
      },
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/garage-insurance`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CertificateGarageInsuranceInsurance />
          </AuthorizedRoute>
        ),
      },
    
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/garage-insurance/:garageNumber`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CertificateGarageInsuranceInsurance />
          </AuthorizedRoute>
        ),
      },
      {
        path: `/business-policy/:customerId/certificate-of-insurance/:customerPolicyId/garage-insurance/duplicate/:garageNumber`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
            <CertificateGarageInsuranceInsurance isDuplicate />
          </AuthorizedRoute>
        ),
      },
]